export default {
  app_bar: {
    title: "Online Matriculation System / KMITL-1",
    homepage: "Homepage",
    login: "Login",
    logout: "Logout",
    undergraduate: "Undergraduate",
    graduate: "Graduate",
    info: "Information for Undergraduate ",
    info_graduate: "Information for Graduate",
    list: "List of Undergraduate",
    list_graduate: "List of Graduate",
    university_name: "King Mongkut's Institute of Technology Ladkrabang",
    main: "Matriculate",
    questionnaire: "Questionnaire",
    manual_student: "Matriculation Manual",
    manual_officer: "Matriculation Manual for Officer",
  },
  drawer: {
    main_menu: 'Main Menu',
    matriculation_system: 'Matriculation System',
    user_account: 'User Account',
    personnel_record: 'Personnel Record',
    officer: "ตรวจรายงานตัว",
    manual: 'Manual',
    user_management: 'User Management',
    config: 'Configuration',
  },
  landing: {
    system: "Online Matriculation System / KMITL-1",
    undergraduate: "Undergraduate",
    graduate: "Graduate",
    info: "Information",
    document: "Document",
    list: "List",
  },
  kmitl1: {
    title: "KMITL-1",
    not_complete: "Matriculation is not complete",
  },
  info: {
    system: "Online Matriculation System / KMITL-1",
    admityear: "Admit Year",
    undergraduate: "Undergraduate",
    graduate: "Graduate",
    maininfo: "Information / Document Form",
    info: "Information",
    documentform: "Document Form",
    document: "Document",
    form: "Form",
    select: "You can choose Thai or English version either",
    version_th: "เวอร์ชันภาษาไทย",
    version_en: "English Version",
    form1: "Documents and procedures for admission",
    form2: "New student regulations",
    form3: "Academic calendar",
    form4: "Photo upload details",
    doc1: "Consent Form for the Use and Processing of Personal Data",
    doc2: "Matriculation of Confirmation Form and Certified the Accuracy of the Information",
    doc3: "Enrollment confirmation Form and Matriculation of Graduate Level and Qualify of English Proficiency Test",
    doc4: "Late Submission of Documents Form (Only for those who do not have a complete transcript)",
    have_not_fill_page_before: "*No previous data saved yet.",
    open: "The online matriculation system will be opened at 8:30 am. on the first day, specified for each round.",
    close: "The online matriculation system will be closed at 4:00 pm. on the last day, specified for each round.",
    ungrad_recommendation: "Recommendation for Online Matriculation Undergraduate Level << Click >>",
  },
  list: {
    system: "Online Matriculation System / KMITL-1",
    admityear: "Admit Year",
    undergraduate: "Undergraduate",
    graduate: "Graduate",
    prestudent_list: "List of Pre-Student",
    faculty: "Please Select Faculty / College",
    curriculum: "Please Select Curriculum",
    search: 'Search with "Apply-Id" or "Student-Id" or "Name"',
    apply_number: "Apply-Id",
    student_id: "Student-Id",
    name: "Name",
    surname: "Surname",
    status: "Status",
    validate: "Validate",
  },
  login: {
    prestudent_authen_title: "'Register/Apply ID' and 'Password' Authentication",
    prestudent_authen_text: "Using admission account",
    officer_student_authen: "Login for Staff / Teacher / Current Students",
    google_authen_title: "Google Authentication",
    google_authen_text: "Using university's email account",
    university_authen_title: "University's account Authentication",
    university_authen_text: "Using university's account",
    guidance: "Guidance",
    guidance_title: "Please log in as the same 'Register / Apply ID' and 'Password' are used with KMITL Admission System.",
    guidance_text: "When students 'Confirm Matriculation' or the matriculation has been verified by the officer. The system will 'lock' the student to not be able to edit the information. Unless there is information that doesn't pass the check. (Students must log in to edit again)",
  },
  request_password: {
    title: "Create / Forgot Password",
    text: "Please enter your Register/Apply ID and Citizen/Passport ID used in Admission",
    text2: "Please enter new password",
    button: "Reset Password",
    button2: "Create Password",
    home_button: "Back to Login page",
  },
  info_card: {
    all_7page: "KMITL1 Page",
    title_page1: "1 / 9 Student Info",
    title_page2: "2 / 9 Personal Information",
    title_page3: "3 / 9 Education Background",
    title_page4: "4 / 9 Father's Information",
    title_page5: "5 / 9 Mother's Information",
    title_page6: "6 / 9 Parent's Information",
    title_page7: "7 / 9 Consent to Use and Disclose Information",
    title_page8: "8 / 9 Student Photo",
    title_page9: "9 / 9 Documents",

    text_info:
      "ข้อมูลที่ให้นักศึกษากรอกใน สจล.1 เป็น 'ข้อมูลรายบุคคลของนักศึกษาในสถาบันอุดมศึกษา' ที่กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม (อว.) กำหนด",

    page2_text:
      "*** Please enter the Email that students are currently able to use. Computer Services Center KMITL will send username / password (for students of KMITL) via student Email, filled in according to the announcement period.",
    page3_text: `If unlisted school name, send school name and address to email : admission-reg&#64;kmitl.ac.th`,
    page32_text: `If unlisted university name, send university name and address to email : grad-reg&#64;kmitl.ac.th`,

    faculty: "Faculty : ",
    curriculum: "Curriculum : ",
    degree: "Degree : ",
    name_th: "Name (TH) : ",
    surname_th: "Surname (TH) : ",
    gender: "Gender",
    prename: "Prename",
    name_en_title: "Name (English)",
    surname_en_title: "Surname (English)",
    name_en: "Name (English) (UPPERCASE only)",
    surname_en: "Surname (English) (UPPERCASE only)",

    thai_citizenID: "Citizen ID : ",
    thai_citizenID_start_date: "Date of Issue",
    thai_citizenID_end_date: "Date of Expiry",
    email: "Email",
    mobile: "Mobile",
    birth_date: "Birthday",
    nation: "Nationality",
    race: "Ethnicity",
    religion: "Religion",
    talent: "Talent",
    disability: "Disability",
    disabilityPlease:
      "Students with physical disabilities Please fill out information for disabled persons card.",
    disabilityId: "Disability Identification Code",
    disabilityStartDate: "The date of issue of the identity card for the disabled",
    disabilityEndDate: "Expiration date disabled identity card",
    foreign_student: "Foreign student please fill your passport information",
    passport_number: "Passport Number",
    passport_start_date: "The date of issue of the passport",
    passport_end_date: "Passport expiration date",

    address_registration: "Permanent Address",
    address_contact: "Temporary Address",
    address_same: "Like Permanent Address",
    address_new: "Add Mailing Address",
    house_id: "House ID",
    house_number: "House Number",
    village_name: "Village",
    moo: "Village No.",
    soi: "Lane",
    street: "Road",
    province: "Province/State",
    district: "District",
    sub_district: "Sub-District",
    in_thai: "In Thailand",
    foreign_country: "In Other Countries",
    country: "Country",

    school_location: "Location of graduate School",
    university_location: "Location of graduate University",
    university_name: "University Name",
    school_name: "School Name",
    school_type: "School Type",
    education_type: "Education Type",
    school_student_id: "Student ID in School",
    school_grad_date: "Date of graduation",
    school_grad_date_detail:
      "*The graduated date must be as same as the graduation document submitted to KMITL.",
    GPA_hint: "GPAX (If don't have GPAX, fill 0.00 in this field)",
    first_encounter: "KMITL's Student status record",
    first_time: "First Time entry",
    second_time: "Re-entry",
    old_studentID: "Student ID (When study in KMITL)",
    faculty_college: "Faculty / College",
    curriculum_name: "Curriculum",
    graduated_year: "Graduate Year (A.D.)",

    vital_status: "Vital Status",
    live: "Live",
    passaway: "Pass away",
    no_information: "Unable to find information",
    occupation: "Occupation",
    revenue: "Revenue",
    address: "Address",
    parent_address: "Like Permanent Address's Student",
    parent_contact: "Like Mailing Address's Student",
    parent_new_address: "Add Address",
    father: "Father",
    mother: "Mother",
    thai_parent: "Thai People",
    foreigner_parent: "Foreigner",
    new_parent: "Another person",
    relative: "Relative",
    parent_status: "Status between father and Mother",

    thai: "Thai Student",
    foreigner: "Foreign Student",
    fill_thai_citizenID: "CitizenID Number",
    fill_passport_number: "Passport Number",
    textWarning:
      "*Parental information must specify exactly as the document of consent for disclosure and a document of confirmation for reporting",
    p7_title1: "การยินยอมให้ใช้ข้อมูล",
    p7_text1:
      "ข้าพเจ้ารับทราบและยินยอมให้สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณ ทหารลาดกระบัง (ต่อไปนี้ เรียกว่า “สถาบันฯ”) และ/หรือ บุคคล และ/หรือ นิติบุคคล ที่ได้รับมอบหมาย บันทึกข้อมูล และใช้ข้อมูลของ ข้าพเจ้า (เช่น ข้อมูลที่ข้าพเจ้าให้แก่สถาบันฯ ข้อมูลที่เกิดจากการใช้ ระบบสารสนเทศของสถาบันฯ และข้อมูลอื่น ๆ) ในการทำธุรกรรม และ/หรือ การใช้บริการของข้าพเจ้า เพื่อประโยชน์ในการให้บริการแก่ ข้าพเจ้า และ/หรือ เพื่อประโยชน์อื่นใดที่ข้าพเจ้าได้ให้ความยินยอมไว้ แก่สถาบันฯ รวมถึง เพื่อการวิเคราะห์ข้อมูล เสนอ ให้ ใช้ และ/หรือ ปรับปรุงกระบวนการหรือบริการอื่น นอกจากนี้ สถาบันฯ อาจใช้ ข้อมูลของข้าพเจ้าเพื่อการปฏิบัติตามกฎระเบียบต่าง ๆ ของสถาบันฯ ทั้งนี้ แม้ว่าข้าพเจ้าจะไม่มีสถานภาพนักศึกษาสถาบันฯ แล้วก็ตาม",
    p7_title2: "การยินยอมให้เปิดเผยข้อมูล",
    p7_text2:
      "ข้าพเจ้ามีสิทธิในความเป็นส่วนตัวในข้อมูลของข้าพเจ้า และสถาบันฯ จะไม่เปิดเผยข้อมูลของข้าพเจ้าให้แก่บุคคล และ/หรือ นิติบุคคลอื่น เว้นแต่ในกรณีดังต่อไปนี้",
    p7_text21:
      "การเปิดเผยข้อมูลให้แก่บุคลากรผู้ที่ได้รับอนุญาตของสถาบันฯ ซึ่ง ได้แก่ บุคลากรในส่วนงานของสำนักงานอธิการบดีส่วนงาน วิชาการ และส่วนงานอื่นภายในสถาบันฯ ทั้งนี้ หากไม่ใช่บุคลากร ผู้ได้รับอนุญาตตามที่กล่าวข้างต้น แต่มีความจำเป็นต้องเปิดเผย ข้อมูลส่วนบุคคลของข้าพเจ้า สถาบันฯ จะทำหนังสือขอความ ยินยอมจากข้าพเจ้าเป็นกรณีๆ ไป",
    p7_text22:
      "การเปิดเผยข้อมูลเพื่อให้ข้าพเจ้าสามารถทำธุรกรรม และ/หรือ ใช้ บริการที่ข้าพเจ้าประสงค์ได้ ทั้งนี้ การเปิดเผยข้อมูลดังกล่าวจะไม่ เป็นไปเพื่อแสวงหาผลกำไรจากการใช้ข้อมูลดังกล่าว",
    p7_text23:
      "การเปิดเผยข้อมูลดังกล่าวเป็นไปเพื่อปฏิบัติตามกฎหมาย เพื่อการ สอบสวนหรือการดำเนินการทางกฎหมาย",
    p7_text24:
      "การเปิดเผยข้อมูลดังกล่าวเป็นไปตามกฎหมายหรือตามคำสั่งของ หน่วยงานรัฐ หรือหน่วยงานกำกับดูแลสถาบันฯ ",
    p7_text25:
      "การเปิดเผยข้อมูลให้แก่บุคคล และ/หรือ นิติบุคคล ที่สถาบันฯ ได้รับ ความยินยอมจากข้าพเจ้า ตามวัตถุประสงค์ดังกล่าวข้างต้น จะเป็นไป เพื่อประโยชน์แก่ข้าพเจ้าและไม่เป็นการแสวงหาผลกำไร ทั้งนี้ หากมี ความจำเป็นต้องเปิดเผยข้อมูลของข้าพเจ้าให้แก่บุคคล และ/หรือ นิติ บุคคลที่ไม่ได้กล่าวมาข้างต้น สถาบันฯ จะทำหนังสือขอความยินยอม จากข้าพเจ้าเป็นกรณีๆ ไป",
    p7_textAgree:
      "ข้าพเจ้าตกลงยินยอมให้ใช้และเปิดเผยข้อมูลของข้าพเจ้าตามที่ระบุข้างต้น (กรณีผู้ยินยอมให้ใช้และเปิดเผยข้อมูลเป็นผู้เยาว์ ต้องได้รับความยินยอมจากบิดา มารดา หรือผู้ปกครองตามกฎหมาย)",
  },
  footer: {
    registrar: "KMITL Registration and Educational Service Office",
    address1: "1 Soi Chalong Krung 1",
    address2: "Ladkrabang Subdistrict, Ladkrabang District,",
    address3: "Bangkok 10520",
    contact_undergraduate: "Contact : Undergraduate",
    contact_graduate: "Contact : Graduate",
    ext: "ext.",
  },
  toast: {
    save_successfully: "Saved Successfully",
    cannot_save: "Cannot Save",
    create_successfully: "Create Successfully",
    cannot_create: "Cannot Create",
    upload_successfully: "Upload Successfully",
    cannot_upload_file: "Cannot Upload File",
    delete_successfully: "Delete Successfully",
    cannot_delete: "Cannot Delete",
    edit_successfully: "Edit Successfully",
    cannot_edit: "Cannot Edit",
    mail_sent: "Your email has been sent",
    mail_sent_to: "Email has been sent to",
  },
  config: {
    addnew: "Add",
    edit: "Edit",
    delete: "Delete",
    number: "#",
    save: "Save",
    cancel: "Cancel",
  },
  config_year: {
    config_year: "Config Admit Academic",
    admit_year: "Admit Year",
    admit_semester: "Admit Semester",
    level_id: "Level",
    start_datetime_system: "Start Datetime System",
    admit_date: "Admit Date",
  },
  config_round: {
    config_round: "Config Round",
    config_year: "Admit Semester/Year",
    round_name_th: "Round Name in Thai",
    round_name_en: "Round Name in English",
    round_start_datetime: "Start Marticulation Date",
    round_end_datetime: "End Marticulation Date",
  },
  config_document: {
    config_document: "Config Document",
    level_id: "Level",
    document_type_name_th: "Document Name in Thai",
    document_type_name_en: "Document Name in English",
    required: "Required",
    order: "Order",
    example_filepath: "Example Filepath",
    form_filepath: "Form Filepath",
    enabled: "Enabled",
  },
  officer: {
    find_edit_data: "ค้นหา / แก้ไขข้อมูลเริ่มต้น",
    main_officer: "ตรวจรายงานตัว / สวมสิทธิ์",
    kmitl1: "เรียกดู สจล.1",
    export_data: "นำเข้านักศึกษาสู่ระบบหลัก",
    check: "ระดับปริญญาตรี",
    check_grad: "ระดับบัณฑิตศึกษา",
  },
  main: {
    status: "Status of Marticulation",
    comment: "Items to be Corrected as follows:",
    has_comment_for_photo: "Item 8 : ",
    has_comment_for_document: "Item 9 has document revisions. Please view the details.",
    step_of_marticulation: "Procedure",
    step_of_marticulation_detail:
      'The matriculation status will be "Completed" when',
    step_of_marticulation_1: "1) Please ensure that all 9 fields in KMITL-1 form are filled out completely.",
    step_of_marticulation_2: '2) Click the "Submit Matriculation" button.',
    step_of_marticulation_3: "3) Wait for the verification results from the officer.",
    step_of_marticulation_4:
      '4) If the verification result is "Have not passed" please make corrections according to the "Items to be Corrected" list and resubmit as per step 2).',
    step_of_marticulation_5:
      '5) If the verification is successful, the status will be displayed as "Completed"',
    confirm_commit: "Submit Matriculation",
    remark: "Remark",
    remark_1:
      '- After completing all 9 fields, you will be able to press the "Submit Matriculation" button.',
    remark_2:
      '- After pressing the "Submit Matriculation" button, all 9 fields will be locked and unable to be edited.',
    remark_3:
      '- If the status of the report is "Have not passed", please fill in or upload again according to the "Items to be Corrected" list.',
    page1: "1 : Student Info",
    page2: "2 : Personal Information",
    page3: "3 : Education Background",
    page4: "4 : Father's Information",
    page5: "5 : Mother's Information",
    page6: "6 : Parent's Information",
    page7: "7 : Information Consent",
    page8: "8 : Student Photo",
    page9: "9 : Documents",
    round_locked: 'The student is not in the matriculation period. Please check the schedule on the menu "Information"',
  },
  timeline: {
    symbol: "Symbol",
    not_complete: "Have not completed",
    complete: "Completed",
    can_not_edit: "Not editable",
    can_edit: "Editable",
  },
  upload: {
    choose_files: "Choose Files",
    upload: "Upload",
    clear: "Clear",
    drag_and_drop: "Drag and drop files here",
    support_file_types: "Supported file types",
    max_file_size: "Maximum file size",
    max_num_files: "Maximum number of files allowed",
    pending: "Pending",
    alert: "Alert",
    alert_text: 'Don\'t forget to press the "Upload" button.',
    close: "Close",
    file: "File",
    view_file: "View File",
  },
  upload_photo: {
    status: "Status",
    uploaded: "Student photo have been uploaded",
    not_upload: "Student photo have not been uploaded yet",
    correction_details: "Correction details",
    example: "Example",
  },
  upload_doc: {
    status: "Status",
    uploaded: "All documents have been uploaded",
    not_upload: "The documents have not been uploaded yet",
    required: "Required",
    optional: "Optional",
    correction_details: "Correction details",
    example_file: "Example file",
    download_form: "Download Form",
    delete_all_files: "Delete all files",
  },
  questionnaire: {
    title:
      "Evaluate the satisfaction questionnaire of the online matriculation system.",
    general_information: "The general information of the respondents.",
    Q0_1: "What device do you primarily use to access our system?",
    Q0_2: "How do you typically stay informed about news and updates related to our system?",

    level_satisfaction_user: "Level of satisfaction of clients",
    please_fill_in_truth:
      "*** Please fill in the truth to use as information for improving systems and services. ***",
    header_table1: "Attribute",
    header_table2: "Level (1: Very dissatisfied to 5: Very satisfied)",
    header_table2_hint:
      "(Please give the star symbol according to your satisfaction level.)",
    news_source_specify: "Please specify the news source.",
    Q1: "1. Process",
    Q1_1: "1.1 Easy to use the system (User-Friendly).",
    Q1_2: "1.2 There is an appropriate matriculation procedure.",
    Q1_3: "1.3 There is an appropriate basic recording procedure.",
    Q1_4: "1.4 Ease of filling out information that is related to each other.",
    Q1_5: "1.5 Convenience in uploading images or supporting documents for identification.",
    Q2: "2. Quality of Content",
    Q2_1: "2.1 There is easy to link the information inside the website. ",
    Q2_2: "2.2 There is easy access to the website.",
    Q2_3: "2.3 There is the suitability of the information within the website.",
    Q2_4: "2.4 There is an accuracy and completeness of information.",
    Q2_5: "2.5 There is an appropriate public relations for matriculation.",
    Q3: "3. Design",
    Q3_1: "3.1 There is a beautiful, modern and attractive website.",
    Q3_2: "3.2 They are formatted within the website that are easy to read and use.",
    Q3_3: "3.3 There are font sizes and styles that easy to read.",
    Q3_4: "3.4 There are fast in displaying images, characters and other information.",
    Q3_5: "3.5 How complete do you think this matriculation system is.",

    additional_info: "More information",
    additional_1:
      "Guidelines for program improvement / system development / what to expect",
    additional_2: "More Suggestions / Other Suggestions",
    please_rate: "Please rate",
  },
  generate: {
    title: "Generate Student ID",
    topic: "Select Route",
    level: "Degree",
    year: "Year",
    mode: "Mode",
    confirm: "Confirm",
    data: "Download Data",
  },
  insert: {
    title: "Import Register (Individual/All)",
    sub_title: "Import Register from Admission System to Matriculation System (Individual/All)",
    level: "Degree",
    year: "Year",
    semester: "Semester",
    apply_id: "Apply ID",
    search: "Search",
    name: "Name",
    surname: "Surname",
    add_student: "Add Student",
    reset: "Reset",
  },
  export: {
    title: "Export Student to Main System",
    sub_title: "Export Student from Matriculation System to Main System",
    level: "Degree",
    year: "Year",
    semester: "Semester",
    student_id: "StudentID",
    search: "Search",
    name: "Name",
    surname: "Surname",
    add_student: "Add Student",
    reset: "Reset",
  },
};
